import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnInit, Signal, ViewChild, computed, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrderHistoryService } from '../order-and-billing.service';
import { BillingDetailItem, OrderHistoryDetailResponse, OrderHistoryProductResponse } from '../order-and-billing.types';
import { ResolutionService } from '../../../../shared/resolution.service';
import { NotificationService } from '../../../../shared/notification/notification.service';
import { MatProgressBar } from '@angular/material/progress-bar';
import { FileRequestService } from '../../../../shared/file-request.service';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-order-detail',
    imports: [CommonModule, MatProgressBar],
    providers: [OrderHistoryService],
    templateUrl: './order-detail.component.html',
    styleUrl: './order-detail.component.scss'
})
export class OrderDetailComponent implements OnInit {

  @ViewChild('contentToPrint') contentToPrint!: ElementRef;

  private activatedRoute = inject(ActivatedRoute);
  private orderHistoryService = inject(OrderHistoryService);
  private resolutionService = inject(ResolutionService);
  private notificationService = inject(NotificationService);
  private fileRequestService = inject(FileRequestService);

  orderDetail: Signal<OrderHistoryDetailResponse | null> = computed(() => this.orderHistoryService.orderHistoryDetail());
  billingDetail: Signal<BillingDetailItem[]> = computed(() => this.orderHistoryService.billinDetail());
  isMobile = computed(() => this.resolutionService.isMobile());
  /** The invoice is fetched now instead of being a plain link, so the button has to say so. */
  isInvoiceLoading = signal(false);

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      const id = +params["order"]
      this.orderHistoryService.getOrderHistoryDetail(id);
    })
  }

  printInvoice() {
    const invoiceURL = this.orderDetail()?.payment?.invoiceURL;
    if (!invoiceURL) return this.notificationService.show({ text: 'There is no invoice to see', type: 'warning' })

    // Opened inside the click, before anything is awaited — see FileRequestService (DEV-11537).
    const tab = this.fileRequestService.openPendingTab();
    this.isInvoiceLoading.set(true);

    this.fileRequestService.showInTab(tab, invoiceURL).pipe(
      finalize(() => this.isInvoiceLoading.set(false))
    ).subscribe();
  }

  viewMoreItems(delivery: OrderHistoryProductResponse) {
    delivery.isViewAllItems.update(value => !value);
  }

}
